module.exports = __webpack_public_path__ + "static/media/draggable-icon.ca0c0451.svg";